import React from 'react';
import Navbar from './components/Navbar';
import './App.css';
import Home from './components/pages/Home';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Services from './components/pages/Services';
import Content from './components/pages/Content';
import UsefulTools from './components/pages/UsefulTools';
import WindowsEOL from './components/pages/WindowsEOL';
import MSSecurityCVEs from './components/pages/MSSecurityCVEs';
import AzureEOL from './components/pages/AzureEOL';
import BlogList from './components/pages/BlogList';
import BlogEditor from './components/pages/BlogEditor';
import BlogView from './components/pages/BlogView';
import SignUp from './components/pages/SignUp';
import Notes from './components/pages/Notes';
import Profile from './components/pages/Profile';
import Me from './components/pages/Me';
import ComingSoon from './components/pages/ComingSoon';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/services' component={Services} />
        <Route path='/content' exact component={Content} />
        <Route path='/content/:category' component={BlogList} />
        <Route path='/tools' exact component={UsefulTools} />
        <Route path='/tools/windows-eol' component={WindowsEOL} />
        <Route path='/tools/ms-security-cves' component={MSSecurityCVEs} />
        <Route path='/tools/azure-eol' component={AzureEOL} />
        <Route path='/blog/create' component={BlogEditor} />
        <Route path='/blog/edit/:id' component={BlogEditor} />
        <Route path='/blog/:id' component={BlogView} />
        <Route path='/sign-up' component={SignUp} />
        <Route path='/login' component={SignUp} />
        <ProtectedRoute path='/notes' component={Notes} />
        <ProtectedRoute path='/profile' component={Profile} />
        <Route path='/about/me' component={Me} />
        <Route path='/about/coming-soon' component={ComingSoon} />
      </Switch>
    </Router>
  );
}

export default App;
